import React from 'react'

import classes from './CardSkeleton.module.scss'

export const CardSkeleton = () => {
  return (
    <div className={classes.Container}>
      <div className={classes.Body}>
        <div className={classes.TeamInfo}>
          <span className={classes.Logo}></span>
          <span className={classes.Title}></span>
        </div>
        <div className={classes.GameInfo}>
          <span className={classes.Title}></span>
          <span className={classes.GameScore}></span>
          <span className={classes.PastEventDate}></span>
        </div>
        <div className={classes.TeamInfo}>
          <span className={classes.Logo}></span>
          <span className={classes.Title}></span>
        </div>
      </div>
      <div className={classes.Footer}>
        <span className={classes.Badge}></span>
        <span className={classes.Badge}></span>
      </div>
    </div>
  )
}
